module.exports = __webpack_public_path__ + "img/emprendimiento-innovacion.9ce2aa4d.svg";